const routes = [
    {
        path: '/mdfe/manifestos',
        alias: ['/mdfe/manifestos/index'],
        component: () => import('../views/Listar')
    },
    {
        path: '/mdfe/manifestos/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        path: '/mdfe/manifestos/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        path: '/mdfe/manifestos/visualizar/:id',
        component: () => import('../views/Visualizar')
    },
    {
        name: 'importarXml',
        path: '/mdfe/manifestos/importar_xml',
        component: () => import('../views/ImportarXml')
    },
    // {
    //     path: '/mdfe/manifestos/importar_cadastros',
    //     component: () => import('../views/Importar')
    // },
]

export default routes